export interface Filter {
  text: string,
  value: string
}

export enum SearchData {
  Requests,
  Drafts
}

export interface Option {
  label: string,
  value: string
}
